import {
  GetBucketCollegesOptions,
  GetBucketOptions,
  GetBucketResponse,
  RecommendationsService,
  RecommendedCollege,
} from 'src/services/RecommendationsService';
import {uuid4} from 'shared/utils';
import {
  clearRecommendations,
  DELETE_BUCKET,
  FETCH_RECOMMENDATIONS,
  LOAD_RECOMMENDATIONS,
  recommendationsShown,
} from 'recommendations/redux';
import {flashMessage} from 'shared/actions/notifications';
import Errors from 'src/static/errors.json';
import {getSponsoredRecommendations, sponsoredRecommendationBucket} from './campaigns';

type GetRecommendationBucketCollegeOptions = Omit<GetBucketCollegesOptions, 'bucketEventId'>;

export function recommendationsLoaded(bucketId: string, colleges: RecommendedCollege[]) {
  return {
    type: LOAD_RECOMMENDATIONS,
    id: bucketId,
    recommendedColleges: colleges,
    bucketShownEventId: uuid4(),
  };
}

export function getRecommendationBucketColleges(options: GetRecommendationBucketCollegeOptions) {
  return async (dispatch: $TSFixMe) => {
    dispatch({type: FETCH_RECOMMENDATIONS, id: options.bucketId});
    const allOptions = {...options, bucketEventId: uuid4()};
    let colleges: RecommendedCollege[];

    try {
      colleges = await RecommendationsService.getRecommendationBucketColleges(allOptions);
    } catch (error) {
      console.error(`Error getting bucket [${options.bucketId}]...deleting`, error);
      return dispatch({type: DELETE_BUCKET, id: options.bucketId});
    }

    if (colleges.length === 0) {
      console.info(`No colleges in bucket [${options.bucketId}]...deleting`);
      return dispatch({type: DELETE_BUCKET, id: options.bucketId});
    }

    return dispatch(recommendationsLoaded(options.bucketId, colleges));
  };
}

// Maximum number of buckets to fetch at once
const MAX_BUCKETS = 3;

export function getBuckets(limit: number, options: GetBucketOptions = {}) {
  return async (dispatch: $TSFixMe) => {
    let buckets: GetBucketResponse[];
    dispatch(clearRecommendations());

    try {
      buckets = await RecommendationsService.getBuckets(limit, options);
      const recommendationsShownEventId = uuid4();

      dispatch(
        recommendationsShown(
          recommendationsShownEventId,
          buckets.concat([sponsoredRecommendationBucket])
        )
      );

      dispatch(getSponsoredRecommendations(5));

      buckets.slice(0, MAX_BUCKETS).forEach((bucket, bucketIndex) => {
        bucket &&
          dispatch(
            getRecommendationBucketColleges({
              skipCache: options.skipCache,
              imposterStudentId: options.imposterStudentId,
              recommendationsShownEventId,
              totalBucketCount: buckets.length,
              bucketId: bucket.id,
              bucketIndex,
            })
          );
      });
    } catch (error) {
      console.error('Failed to load buckets', error);
      dispatch(flashMessage(Errors.genericError, 'error'));
    }
  };
}
